import { Source } from 'src/types';
import { SourceActions } from '../actions/sources';

const initialState: {
	messageId: string;
	sources: Source[];
	internetSources: Source[];
	unusedSources: Source[];
} | null = null;

const sourcesReducer = (state = initialState, action: SourceActions) => {
	switch (action.type) {
		case 'source/add':
			return {
				...(state || { internetSources: [], unusedSources: [] }),
				messageId: action.payload.messageId,
				sources: action.payload.sources
			};

		case 'source/add-internet':
			return {
				...(state || { sources: [], unusedSources: [] }),
				messageId: action.payload.messageId,
				internetSources: action.payload.internetSources
			};
		case 'source/remove-all':
			return null;
		case 'message/add-complete-chunk': {
			const { questionId, sources, internetSources } = action.payload;
			return {
				messageId: questionId,
				sources: sources || [],
				internetSources: internetSources || []
			};
		}
		default:
			return state;
	}
};

export default sourcesReducer;
